<template>
  <div class="main_add_ride" :dir="isHebrew ? 'rtl' : 'ltr'" :lang="isHebrew ? 'he' : 'en'">
    <div class="privacy-header d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
      <h1 class="main-ride-titles mb-0">{{ t('privacyPolicy') }}</h1>
      <b-button variant="primary" size="lg" @click="goBack" class="pp-back-button" :dir="isHebrew ? 'rtl' : 'ltr'">
        <i :class="isHebrew ? 'fas fa-arrow-right' : 'fas fa-arrow-left'"></i>
        {{ t('backToPrevious') }}
      </b-button>
    </div>
    <div class="add_ride_boxes_text">
      <p>{{ t('ppIntro') }}</p>
      <h3>{{ t('ppInfoCollection') }}</h3>
      <p>{{ t('ppInfoCollectionContent') }}</p>
      <h3>{{ t('ppInfoUse') }}</h3>
      <p>
        {{ t('ppInfoUseContent') }}
        <ul>
          <li>{{ t('ppInfoUseItem1') }}</li>
          <li>{{ t('ppInfoUseItem2') }}</li>
          <li>{{ t('ppInfoUseItem3') }}</li>
          <li>{{ t('ppInfoUseItem4') }}</li>
        </ul>
      </p>
      <h3>{{ t('ppCookies') }}</h3>
      <p>{{ t('ppCookiesContent1') }}</p>
      <p>{{ t('ppCookiesContent2') }}</p>
      <h3>{{ t('ppExternalServices') }}</h3>
      <p>{{ t('ppExternalServicesContent1') }}</p>
      <p>{{ t('ppExternalServicesContent2') }}</p>
      <h3>{{ t('ppDataSecurity') }}</h3>
      <p>{{ t('ppDataSecurityContent') }}</p>
      <h3>{{ t('ppPolicyChanges') }}</h3>
      <p>{{ t('ppPolicyChangesContent') }}</p>
      <h3>{{ t('ppContactHeading') }}</h3>
      <p>{{ t('ppContactContent') }}</p>
      <h4 class="pp-last-updated">{{ t('ppLastUpdated') }}</h4>
      <div class="d-flex justify-content-start mt-4 mb-4">
        <b-button variant="primary" size="lg" @click="goBack" class="pp-back-button" :dir="isHebrew ? 'rtl' : 'ltr'">
          <i :class="isHebrew ? 'fas fa-arrow-right' : 'fas fa-arrow-left'"></i>
          {{ t('backToPrevious') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { translationMixin } from "@/mixins/translationMixin";

export default {
  name: 'PrivacyPolicy',
  mixins: [translationMixin],
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.privacy-header {
  flex-direction: row;
}
/* Hebrew (RTL): title on the right, return button on the left — no row-reverse so first item (title) is at start (right), second (button) at end (left) */
.main-ride-titles {
  color: #07A0C3;
  text-align: start;
}
.pp-back-button {
  white-space: nowrap;
}
.add_ride_boxes_text {
  color: #212529;
  line-height: 1.8;
  font-size: 1.8rem;
  text-align: start;
}
.add_ride_boxes_text ul {
  list-style-type: disc;
  padding-inline-start: 2rem;
}
.add_ride_boxes_text h3 {
  color: #07A0C3;
  margin-top: 3rem;
  margin-bottom: 1rem;
  font-size: 2.4rem;
  font-weight: 700;
}
.add_ride_boxes_text h4,
.add_ride_boxes_text .pp-last-updated {
  font-size: 1.6rem;
  color: #A59898;
  margin-top: 3rem;
}
</style>
